import { render, staticRenderFns } from "./shift-change-request.vue?vue&type=template&id=d9657db0"
import script from "./shift-change-request.vue?vue&type=script&lang=js"
export * from "./shift-change-request.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports